import React, { useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Necesito comprar ingredientes caros?',
    a: 'No, todo se encuentra en un supermercado normal.'
  }, {
    q: '¿Es una dieta keto?',
    a: 'No, es un protocolo balanceado que respeta tus necesidades hormonales.'
  }, {
    q: '¿Cuánto tiempo toma ver resultados?',
    a: 'Verás cambios en tu energía y sueño en los primeros 3 a 5 días.'
  }, {
    q: '¿Qué pasa si tomo café?',
    a: 'Te enseñamos cómo tomarlo sin que destruya tu sueño.'
  }, {
    q: '¿Es seguro si tomo medicamentos?',
    a: 'Sí, es comida real, pero siempre recomendamos consultar a tu médico.'
  }, {
    q: '¿El material es físico?',
    a: 'Es un acceso digital inmediato para que empieces esta misma noche.'
  }];
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <SectionWrapper className="bg-brand-surface" data-id="element-23">
      <div className="max-w-3xl mx-auto" data-id="element-24">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-brand-brown mb-12" data-id="element-25">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-26">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl shadow-sm border border-brand-sand overflow-hidden transition-all duration-300" data-id="element-27">
              <button onClick={() => toggleAccordion(index)} className="w-full px-6 py-5 flex justify-between items-center text-left focus:outline-none" data-id="element-28">
                <span className="font-serif text-lg md:text-xl font-semibold text-brand-brown pr-4" data-id="element-29">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUpIcon className="w-6 h-6 text-brand-terracotta flex-shrink-0" data-id="element-30" /> : <ChevronDownIcon className="w-6 h-6 text-brand-terracotta flex-shrink-0" data-id="element-31" />}
              </button>

              <AnimatePresence data-id="element-32">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-33">
                    <div className="px-6 pb-5 font-sans text-brand-brown/80 text-lg leading-relaxed" data-id="element-34">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}